import { render } from "./HomeApp.vue?vue&type=template&id=0a84a186"
import script from "./HomeApp.vue?vue&type=script&lang=js"
export * from "./HomeApp.vue?vue&type=script&lang=js"

import "./HomeApp.vue?vue&type=style&index=0&id=0a84a186&lang=css"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__